import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'cb0051',
    ecrans: ['00-2', '01-2'],
    params: ['pruseq', '?vaesysnivappctr', '?t_prucleint', '?vaeprutypbdg', '?prscleint', '?blocleint', '?cptcleint', '?unacleint', '?cifcleint', '?annfindeb', '?indcleint']
});
